// Rental — shared constants.

// Fixed floor list; the API stores these as the ENUM values GROUND / FIRST.
export const FLOOR_OPTIONS = [
    { value: "GROUND", label: "Ground Floor" },
    { value: "FIRST", label: "First Floor" },
];

export const floorLabel = (floor: any) =>
    FLOOR_OPTIONS.find((f) => f.value === floor)?.label ?? "-";

// AWS "type" location code for rental receipts — see checkType() in
// awsUpload.ts (case 9 -> "rental/receipts/").
export const RENTAL_UPLOAD_TYPE = 9;

export const rentalFileUrl = (fileUuid: string) =>
    `${process.env.REACT_APP_AWS_CLOUD_FRONT_URL}/${process.env.REACT_APP_IMAGE_DESTINATION_BUCKET}rental/receipts/${fileUuid}`;

export const isPdfFile = (fileUuid?: string | null) => /\.pdf$/i.test(fileUuid || "");

// Month dropdown, in financial-year order (April first). Stored as 1-12.
export const MONTH_OPTIONS = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3].map((m) => ({
    value: String(m),
    label: new Date(2000, m - 1, 1).toLocaleString("en-US", { month: "long" }),
}));

export const monthLabel = (month: any) =>
    MONTH_OPTIONS.find((m) => m.value === String(month))?.label ?? "-";

// Start year of the current Indian financial year (Apr–Mar).
export const currentFinancialYearStart = () => {
    const today = new Date();
    return today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
};

// "2026" -> "2026-2027".
export const financialYearLabel = (startYear: any) =>
    startYear ? `${Number(startYear)}-${Number(startYear) + 1}` : "-";

export interface FinancialYear {
    label: string;
    from: string;
    to: string;
}

// Indian financial years (Apr 1 – Mar 31), current one first, labelled
// "2026-2027". Built from today's date so "current" always tracks the calendar.
export const buildFinancialYears = (count: number = 5): FinancialYear[] => {
    const today = new Date();
    const currentStart = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    return Array.from({ length: count }, (_, i) => {
        const start = currentStart - i;
        return { label: `${start}-${start + 1}`, from: `${start}-04-01`, to: `${start + 1}-03-31` };
    });
};

// The store dropdown's default: the kioskLocation row named Ambattur.
export const AMBATTUR_STORE_PATTERN = /ambattur/i;

export const inr = (value: any) =>
    `₹${Number(value ?? 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
